// extracted by mini-css-extract-plugin
module.exports = {"root":"classes_root__1Qf6A","legend-text":"classes_legend-text__3jrvF","price-text":"classes_price-text__1UpjS"};